import { defineStore } from "pinia"
import { fetchWrapper, BASE_URL, OK } from "@/helpers"

export const useAuthStore = defineStore("AuthStore", {
  state: () => {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      // user: null,
      returnUrl: null,
    }
  },
  getters: {
    // computed prop of state
    isLoggedIn() {
      return this.user?.dni ? true : false
    },
  },
  actions: {
    async login(credentials) {
      const { email, password } = credentials
      const response = await fetchWrapper.post(`${BASE_URL}/login`, { email, password })

      if (response.result == OK) {
        // update pinia state
        this.user = response.user
        // store user details and jwt in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(response.user))
        // redirect to previous url or default to home page
        this.$router.push({ name: "Dashboard" })
      }

      return response
    },
    async logout() {
      this.user = null
      localStorage.removeItem("user")
      location.reload()
      //router.push("/login")
    },
    async sendRecoveryPass(email) {
      return await fetchWrapper.post(`${BASE_URL}/send_recovery_mail`, { email })
    },
    async resetPassword(password, passwordc, token) {
      return await fetchWrapper.post(`${BASE_URL}/reset_password`, { new: password, new_confirm: passwordc, token })
    },
  },
})

/*
import { defineStore } from "pinia"

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    user: JSON.parse(localStorage.getItem("user")),
    returnUrl: null,
  }),
  actions: {
    async login(username, password) {
      const user = await fetchWrapper.post(`${baseUrl}/authenticate`, { username, password })

      // update pinia state
      this.user = user

      // store user details and jwt in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user))

      // redirect to previous url or default to home page
      router.push(this.returnUrl || "/")
    },
    logout() {
      this.user = null
      localStorage.removeItem("user")
      router.push("/login")
    },
  },
})
*/
